import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MATERIAL_IMPORTS } from '../../../../material/material-imports';
import { CkEditorComponent } from '../../../../shared/ck-editor/ck-editor.component';
import { SolutionModel } from '@generativ/much-smarter-models';
import { Router, ActivatedRoute } from '@angular/router';
import { ParamsService } from '../../../../shared/params.service';

@Component({
  standalone: true,
  imports: [CommonModule, ...MATERIAL_IMPORTS, CkEditorComponent],
  selector: 'app-solution-list',
  templateUrl: './solution-list.component.html',
  styleUrls: ['./solution-list.component.scss']
})
export class SolutionListComponent implements OnInit {

  @Input() solutions: SolutionModel[];
  @Input() problemId: number;

  problemIdUrl: number;

  constructor(private router: Router, private route: ActivatedRoute, private paramsService: ParamsService) {
    this.problemIdUrl = +this.paramsService.getParamById('problemId', this.route.snapshot);
  }

  ngOnInit() {
  }

  parseWrongAnswer(solution: SolutionModel): string[] {
    return JSON.parse(solution.wrongAnswers);
  }

  /**
   * Navigate to  Create solution.
   */
  onCreateSolution() {
    // If we are in exercise management we don't have problem in link
    const url = this.problemIdUrl ? '../solutions/create' : '../problems/' + this.problemId + '/solutions/create';
    this.router.navigate([url], { relativeTo: this.route });
  }

  onEditSolution(solution: SolutionModel) {
    const url = this.problemIdUrl ? '../solutions/' + solution.id + '/edit' :
      '../problems/' + this.problemId + '/solutions/' + solution.id + '/edit';
    this.router.navigate([url], { relativeTo: this.route });
  }
}
